import '@/assets/scss/style.scss';
import i18n from '@/plugins/i18n';
import { createAppRouter } from '@/router/index';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import '@unocss/reset/normalize.css';
import 'animate.css';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import 'uno.css';
import 'virtual:svg-icons-register';
import VueDompurifyHTML from 'vue-dompurify-html';
import VueDraggableResizable from 'vue-draggable-resizable';
import * as info from '../package.json';
import App from './App.vue';
import { FDMessagePlugin } from './plugins/fdMessage';
import { FDMessageBoxPlugin } from './plugins/fdMessageBox';

const pinia = createPinia();
pinia.use(
  createPersistedState({
    storage: localStorage
  })
);
const router = createAppRouter();

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(i18n);
app.use(ElementPlus);
app.use(VueDompurifyHTML);
app.use(FDMessagePlugin);
app.use(FDMessageBoxPlugin);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.component('VueDraggableResizable', VueDraggableResizable);
app.mount('#app');

declare global {
  interface Window {
    funday: string;
  }
}

window.funday = `funday(${info?.version})`;
